import { render, staticRenderFns } from "./CurrentInformation.vue?vue&type=template&id=324d3a4c&"
import script from "./CurrentInformation.vue?vue&type=script&lang=js&"
export * from "./CurrentInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports